export default __webpack_public_path__ + "static/media/gptIcon.de302c70.svg";